import { useOidcStore } from "vue3-oidc";
import { Configuration, AgenciesApi, UsersApi } from "@socotec.io/user-management-sdk";

/**
 * User Management Client
 * Exports configured REST SDK instances for use in the store.
 * user-management expects a `Bearer` prefixed token.
 */

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_USER_MANAGEMENT_REST_API_URL,
  accessToken: () => `Bearer ${useOidcStore().state.value.token}`,
});

export const agenciesApi = new AgenciesApi(configuration);
export const userManagementUsersApi = new UsersApi(configuration);

export async function fetchAll(client, func, filters = {}, limit = 1000) {
  let page = 1;
  const pageSize = Math.max(filters.pageSize ?? 0, 100);
  let allResults = [];
  let totalCount = null;
  while (true) {
    const { count, results } = await client[func]({
      ...filters,
      pageSize,
      page,
    });

    totalCount = count;
    allResults = allResults.concat(results);
    page += 1;

    if (allResults.length >= totalCount || allResults.length >= limit) {
      break;
    }
  }

  return { results: allResults };
}
